export default function () {
    document.querySelectorAll('.filter-bar a').forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
      
          const self = this;
          const parent = self.closest('ul');
          const filter = self.getAttribute('data-filter');
          const target = parent.getAttribute('data-target') || '';
      
          parent.querySelectorAll('a').forEach(function(a) {
            a.classList.remove('current');
          });
          self.classList.add('current');
      
          if (target) {
            const targetEle = document.querySelector(target);
      
            if (targetEle) {
              targetEle.setAttribute('data-current-filter', filter);
      
              targetEle.querySelectorAll('.filter-item').forEach(function(fi) {
                if (filter === '*' || fi.classList.contains(filter)) {
                  fi.classList.remove('hide');
                  fi.style.display = 'block';
                } else {
                  fi.style.display = 'none';
                  fi.classList.add('hide');
                }
              });
            }
          }
        });
      });
      
}

// /* eslint-disable eqeqeq */
// /* eslint-disable func-names */
// $(document).ready(function() {

//     $('.filter-bar a').on('click', function(e) {

//         e.preventDefault();

//         const self = $(this);
//         const parent = $(this).parents('ul');
//         const filter = self.data('filter');
//         const target = parent.data('target') || '';

//         parent.find('a').removeClass('current');
//         self.addClass('current');

//         if (target) {

//             const targetEle = $(target);

//             if (targetEle) {

//                 targetEle.attr('data-current-filter', filter);

//                 targetEle.find('.filter-item').each(function() {

//                     const fi = $(this);

//                     if (filter == '*' || fi.hasClass(filter)) {

//                         fi.removeClass('hide');
//                         fi.slideDown();

//                     } else {

//                         fi.slideUp(300, function() {

//                             $(this).addClass('hide');

//                         });

//                     }

//                 });

//             }

//         }

//     });

// });
